var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-w-full shadow rounded-sm bg-white border-t border-gray-light"},[_vm._t("header"),_c('div',{staticClass:"p-2"},[_vm._t("content")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }